<style scoped lang="less">
.box-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div {
        font-size: 30px;
        text-align: center;
    }
    img {
        width: 300px;
        height: 300px;
        margin-top: 20px;
        margin-bottom: 20px;
    }
}
</style>
<template>
    <el-dialog :visible.sync="show" fullscreen>
        <div class="box-card">
            <div class="color-primary">{{item.text}}</div>
            <img :src="item.src">
        </div>
    </el-dialog>
</template>
<script>
import { selectImage, selectVideo } from "../../util/event.js";
import { HttpClient } from "../../util/http.js";
import { msgSuccess } from "../../util/toast";
export default {
    components: {},
    data() {
        return {
            loadingSave: false,
            show: false,
            item: { src: "", text: "" },
        };
    },
    created() {},
    methods: {
        bigImage(item) {
            this.item = item;
            this.show = true;
        },
    },
};
</script>